export default {
    start: 'スタート',
    pickLanguage: '言語を選択',
    javascript: 'JavaScript',
    python: 'Python',
    php: 'PHP',
    ruby: 'Ruby',
    java: 'Java',
    typescript: 'TypeScript',
    csharp: 'C#',
    go: 'Go',
    cpp: 'C/C++',
    recommended: '推奨',
    advanced: '上級',
    cs_beginner: 'CS初級',
    how_to_program: 'プログラミングの方法',
    what_is_data: 'データとは？',
    what_are_bits: 'ビットとは？',
    basic_data_types: '基本的なデータ型',
    boolean: 'ブール型',
    integer: '整数型',
    floating_point: '浮動小数点型',
    character: '文字型',
    string: '文字列型',
    functions: '関数',
    cs_intermediate: 'CS中級',
    abstraction: '抽象化',
    code_reusability: 'コードの再利用性',
    recursive_functions: '再帰関数',
    tail_recursion: '末尾再帰',
    non_tail_recursion: '非末尾再帰',
    asymptotic_notation: '漸近記法',
    space_time_complexity: '時間計算量と空間計算量',
    big_o_notation: 'O-記法',
    complexity_classes: '複雑性クラス',
    constant: '定数',
    logarithmic: '対数',
    linear: '線形',
    polynomial: '多項式',
    exponential: '指数',
    factorial: '階乗',
    scope: 'スコープ',
    control_flow: '制御フロー',
    for_for_each_while_loops: 'for,foreach,whileループ',
    list_structures: 'リスト構造',
    fixed_arrays: '固定配列',
    multi_dimensional_arrays: '多次元配列',
    dynamic_arrays: '動的配列',
    hash_tables: 'ハッシュテーブル',
    o_1_lookups: 'O(1)ルックアップ',
    caching: 'キャッシング',
    sorting_algorithms: 'ソートアルゴリズム',
    backend_project_1: 'バックエンド開発1',
    what_are_operating_systems: 'オペレーティングシステム',
    linux_distributions: 'Linuxディストリビューション',
    development_environment: '開発環境',
    cli_scripting: 'CLIスクリプティング',
    standard_stream_io: '標準ストリーム入出力',
    git: 'Git',
    html_css_bootstrap: 'HTML,CSS,Bootstrap',
    frontend_project_1: 'フロントエンド開発1',
    team_dev_one: 'チーム開発1',
    team_dev_two: 'チーム開発2',
    team_dev_three: 'チーム開発3',
    frontend_optional: 'フロントエンド開発（任意）',
    backend_project_2: 'バックエンド開発2',
    client_server_models: 'クライアントとサーバ',
    os_process_management: 'OSプロセス管理',
    ipc: 'プロセス間通信',
    pipes: '名前付き,匿名パイプ',
    unix_sockets: 'UNIXドメインソケット',
    rpc: 'RPC',
    networking_layers: 'ネットワーク層',
    udp_tcp: 'UDP,TCP',
    optional: '任意',
    backend_optional: 'バックエンド開発（任意）',
    cs_advanced: 'CS上級',
    advanced_list_structures: '高度なリスト構造',
    singly_linked_list: '片方向リスト',
    doubly_linked_list: '双方向リスト',
    queue: 'キュー',
    stacks: 'スタック',
    deque: 'デック',
    tree_data_structures: '木構造',
    trees: '木',
    binary_trees: '二分木',
    binary_search: '二分探索',
    balanced_binary_trees: '平衡二分探索木',
    heap_trees: 'ヒープ',
    graphs: 'グラフ',
    functional_programming: '関数型プログラミング',
    testing_qa: 'テストとQA',
    lambdas: "ラムダ",
    callable_objects: "呼び出し可能オブジェクト",
    higher_order_functions: "高階関数",
    closures: "クロージャ",
    frontend_project_4: 'フロントエンド開発4',
    web_api_endpoints: 'WebAPIエンドポイント',
    fetching_server_data: 'データフェッチ',
    json_files: 'JSONファイル',
    web_client_storage: 'ブラウザストレージ',
    single_page_apps: 'SPA',
    oop: 'OOP',
    databases: 'データベース',
    design_patterns: 'デザインパターン',
    software_engineering: 'ソフトウェア工学',
    backend_project_3: 'バックエンド開発3',
    backend_project_4: 'バックエンド開発4',
    backend_project_5: 'バックエンド開発5',
    career_support: '転職サポート',
    backend_framework_specialization: 'バックエンドフレームワーク特化',
    oop_objects: 'オブジェクト',
    oop_abstraction: '抽象化',
    oop_encapsulation: 'カプセル化',
    oop_inheritance: '継承',
    oop_polymorphism: 'ポリモーフィズム',
    oop_generics: 'ジェネリクス',
    rdbms: 'RDBMS',
    sql: 'SQL',
    relational_databases: 'リレーショナル DB',
    oop_web_applications: 'OOP Webアプリケーション',
    server_side_rendering: 'サーバサイドレンダリング',
    uml_diagrams: 'UML図',
    get_post_methods: 'GET/POSTメソッド',
    dynamic_content: '動的コンテンツ',
    reverse_proxy_servers: 'リバースプロキシサーバ',
    world_wide_web: 'World Wide Web',
    web_servers: 'ウェブサーバ',
    cloud_vm: 'クラウドVM',
    http: 'HTTP',
    ssh: 'SSH',
    sftp: 'SFTP',
    domains: 'ドメイン',
    tls_ssl: 'TLSとSSL',
    nginx: 'NGINX',
    domain_registrar: 'ドメインレジストラ',
    dns_records: 'DNSレコード',
    subdomains: 'サブドメイン',
    https: 'HTTPS',
    lets_encrypt: "Let's Encrypt",
    three_tier_architecture: '3層アーキテクチャ',
    model_view_controller: 'MVC',
    data_processing: 'データ処理',
    entity_relationship: 'エンティティ関係',
    shell_commands: 'シェルコマンド',
    schema_scripting: 'スキーマスクリプト',
    database_migrations: 'DBマイグレーション',
    data_seeding: 'シーディング',
    url_routing: 'URLルーティング',
    data_access_layer: 'データアクセス層',
    temporary_storage: '一時ディスク',
    one_to_one: '一対一',
    one_to_many: '一対多',
    many_to_many: '多対多',
    ddl_queries: 'DDL',
    dml_queries: 'DML',
    migration_based: 'マイグレーションベース',
    state_based: '状態ベース',
    dao: 'DAO',
    orm: 'ORM',
    http_cookies: 'HTTPクッキー',
    client_storage: 'クライアントストレージ',
    server_sessions: 'サーバセッション',
    user_authentication: 'ユーザー認証',
    middleware: 'ミドルウェア',
    web_security: 'ウェブセキュリティ',
    emailing: 'メーリング',
    process_scheduling: 'スケジューリング',
    cron_jobs: 'cronジョブ',
    stateful_authentication: 'セッション認証',
    stateless_authentication: 'トークン認証',
    safe_querying: 'クエリの安全性',
    input_validation: '入力検証',
    hashing: 'ハッシング',
    csrf: 'CSRF',
    injection_protection: 'インジェクション保護',
    signing: '署名',
    xss: 'XSS',
    fw_django: 'Django',
    lang_python: 'Python',
    fw_laravel: 'Laravel',
    lang_php: "PHP 8+",
    fw_express: 'Express.js',
    lang_js: "JavaScript",
    fw_ruby_on_rails: 'Ruby on Rails',
    lang_ruby: "Ruby",
    fw_asp_net_core: 'ASP.NET Core',
    lang_csharp: "C#",
    fw_springboot: 'Spring Boot',
    lang_java: 'Java',
    fw_rocket: 'Rocket',
    lang_rust: "Rust",
    project: "プロジェクト",
};
